import React from "react";

class GlobalHeaderSearchErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("Global header search render failed", error);
  }

  componentDidUpdate(prevProps) {
    const { resetKey } = this.props;
    if (prevProps.resetKey !== resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    this.props.onRetry?.();
  };

  handleClear = () => {
    this.setState({ hasError: false });
    this.props.onClear?.();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="ec-global-search-fallback" role="status" aria-live="polite">
          <span className="ec-global-search-fallback__message">
            Search is temporarily unavailable.
          </span>
          <div className="ec-global-search-fallback__actions">
            <button type="button" onClick={this.handleRetry}>
              Retry
            </button>
            <button type="button" onClick={this.handleClear}>
              Clear
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default GlobalHeaderSearchErrorBoundary;
